import { initMap } from '../functions';

$(document).ready(function() {

	const menu = {
        isLoading: false,
        map: null,
        init() {
            $(document).on('click', '.open-menu', this, this.show);
            $(document).on('click', '.close-menu', this, this.hide);


        },
		show(event) {
			const _this = event.data;
			event.preventDefault();

			$('.meniu-desktop').addClass('open');

			if (_this.map == null) {
				_this.map = true;
				initMap('menu-map');
			}
		},
		hide(event) {
			const _this = event.data;
			event.preventDefault();

			$('.meniu-desktop').removeClass('open');
		}
    };

    if ($('.meniu-desktop').length) {
        menu.init();
    }
});



// WEBPACK FOOTER //
// ./resources/assets/js/modules/menu.js